import { all, put, fork, takeEvery, select } from 'redux-saga/effects';
import actions from './actions';
import { get, post, patch } from '@iso/lib/helpers/resApiRequestor';

export function* createNote() {
  yield takeEvery(actions.CREATE_NOTE, function* ({ payload, resolve, reject }) {
    try {
      yield put({
        type: actions.CREATE_NOTE_LOADING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield createNoteAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CREATE_NOTE_SUCCESS,
          loading: false,
          message: result.message,
          result: result.data
        });
        if (resolve) resolve(result); // ✅ send back data to caller
      } else {
        yield put({
          type: actions.CREATE_NOTE_FAILED,
          message: 'Failed to process request',
          loading: false
        });
        if (reject) reject(result.message || 'Failed to process request');
      }
    } catch (error) {
      yield put({
        type: actions.CREATE_NOTE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
      if (reject) reject(error);
    }
  });
}

export function* fetchNotes() {
  yield takeEvery(actions.FETCH_NOTES, function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_NOTES,
        loading: true,
        load_more: payload?.load_more
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchNotesAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_NOTES_SUCCESS,
          loading: false,
          message: result?.message,
          result: result?.data,
          pagination: result?.pagination,
          load_more: payload?.load_more
        });
      } else {
        yield put({
          type: actions.FETCH_NOTES_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_NOTES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateNote() {
  yield takeEvery(actions.UPDATE_NOTE, function* ({ payload, resolve, reject }) {
    try {
      yield put({
        type: actions.UPDATE_NOTE_LOADING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateNoteAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UPDATE_NOTE_SUCCESS,
          loading: false,
          message: result.message,
          result: result.data
        });
        if (resolve) resolve(result); // ✅ send back data to caller
      } else {
        yield put({
          type: actions.UPDATE_NOTE_FAILED,
          message: 'Failed to process request',
          loading: false
        });
        if (reject) reject(result.message || 'Failed to process request');
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_NOTE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
      if (reject) reject(error);
    }
  });
}

export function* pinNote() {
  yield takeEvery(actions.PIN_NOTE, function* ({ payload, resolve, reject }) {
    try {
      yield put({
        type: actions.PIN_NOTE_LOADING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield pinNoteAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.PIN_NOTE_SUCCESS,
          loading: false,
          message: result.message,
          result: result.data
        });
        if (resolve) resolve(result); // ✅ send back data to caller
      } else {
        yield put({
          type: actions.PIN_NOTE_FAILED,
          message: 'Failed to process request',
          loading: false
        });
        if (reject) reject(result.message || 'Failed to process request');
      }
    } catch (error) {
      yield put({
        type: actions.PIN_NOTE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
      if (reject) reject(error);
    }
  });
}

function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}

function createNoteAPI(data, roleAuth) {
  return post(`notes`, data, null, null, roleAuth);
}

function fetchNotesAPI(data, pagination, roleAuth) {
  return get(`notes`, data, pagination, null, null, roleAuth);
}

function updateNoteAPI(data, roleAuth) {
  return patch(`notes`, data, null, roleAuth);
}

function pinNoteAPI(data, roleAuth) {
  return patch(`notes/pin`, data, null, roleAuth);
}

export default function* rootSaga() {
  yield all([fork(createNote), fork(fetchNotes), fork(updateNote), fork(pinNote)]);
}
